<template>
  <SimpleLoadingChartContainer
    ref="chartContainer"
    :chart-options="selectedChartOptions"
    :loading="loading"
    loading-text="Loading Average CII chart data..."
    :elevation="3"
  >
    <template #header>
      <div style="display: flex;align-items: center;">
        <h3
          class="chart-title">
          Average CII
        </h3>
        <v-spacer />
        <ThemedSelector
          v-model="showLegs"
          :items="['All', 'Laden', 'Ballast', 'Port']"
          solo
          flat
          hide-details
          color="primary"
          item-color="primary"
          style="max-width: 120px; font-size: 15px"
          class="my-auto mx-2"
        />
        <ThemedRadioGroup
          v-model="selectedChart"
          row
          class="ma-0 pa-0"
          dense
        >
          <v-radio
            label="Cii"
            value="cii"
          />
          <v-radio
            label="Fouling"
            value="fouling"
          />
        </ThemedRadioGroup>
      </div>
    </template>
  </SimpleLoadingChartContainer>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import SimpleLoadingChartContainer from "../../../core/SimpleLoadingChartContainer.vue";
import ThemedRadioGroup from "../../../core/ThemedRadioGroup.vue";
import ThemedSelector from "../../../core/ThemedSelector.vue";
export default {
  name: "AverageCiiChart",
  components: {
    SimpleLoadingChartContainer,
    ThemedRadioGroup,
    ThemedSelector
  },
  data() {
    return {
      selectedChart: "cii",
      showLegs: "All",
      selectedChartOptions:{}
    };
  },
  computed: {
    ...mapState("cii", ["ciiHistoryLoading"]),
    ...mapState("cii/fouling", ["foulingDataLoading"]),
    ...mapGetters("cii", ["ciiAverageChartOptions"]),
    ...mapGetters("cii/fouling", [
      "foulingAverageChartOptions",
      "foulingAverageSeriesData",
    ]),
    loading() {
      return this.ciiHistoryLoading || this.foulingDataLoading;
    }
  },
  watch: {
    showLegs: {
      handler() {
        this.setUpChartOptions();
      },
      deep: true,
    },

    ciiAverageChartOptions: {
      handler() {
        this.setUpChartOptions();
      },
    },
    selectedChart: {
      handler() {
        this.setUpChartOptions();
      },
      deep: true,
    }
  },
  methods: {
    setUpChartOptions() {
  let chartOptions = {};

  if (this.selectedChart === "cii") {
    chartOptions = JSON.parse(JSON.stringify(this.ciiAverageChartOptions));
  } else {
    chartOptions = JSON.parse(JSON.stringify(this.foulingAverageChartOptions));
  }

  if (this.showLegs === 'All') {
    this.selectedChartOptions = chartOptions;
    return;
  }

  if (!chartOptions.xAxis || !chartOptions.xAxis.plotLines) {
    this.selectedChartOptions = chartOptions;
    return;
  }

  chartOptions.xAxis.plotLines = chartOptions.xAxis.plotLines.filter(item => {
    const text = item && item.label && item.label.text ? item.label.text : '';
    const isPort = text.includes('port_stay');

    if (this.showLegs === 'Port') {
      return isPort;
    }

    if (this.showLegs === 'Ballast') {
      return !isPort && text.includes('(B)');
    }

    if (this.showLegs === 'Laden') {
      return !isPort && text.includes('(L)');
    }

    return true;
  });

  this.selectedChartOptions = chartOptions;
}
  },

};
</script>

<style scoped>
.chart-title {
  color: var(--color-text);
}
</style>
